import { endpoints } from 'Constants';

const authenticationServices = {
	email_login: (params) => ({
		baseURL: endpoints.Authentication.LOGIN_BY_EMAIL(),
		method: 'POST',
		data: params,
	}),
	otp_login: (params) => ({
		baseURL: endpoints.Authentication.LOGIN_BY_OTP(),
		method: 'POST',
		data: params,
	}),
	otp_check: (params) => ({
		baseURL: endpoints.Authentication.CHECK_OTP(),
		method: 'POST',
		data: params,
	}),
	get_sessions: () => ({
		baseURL: endpoints.Authentication.ACTIVE_SESSION(),
		method: 'GET',
	}),
	logout: (params) => ({
		baseURL: endpoints.Authentication.REMOVE_SESSION(),
		method: 'POST',
		data: params,
	}),
	session_check: () => ({
		baseURL: endpoints.Authentication.CHECK(),
		method: 'GET',
	}),
	login_by_id: (params) => ({
		baseURL: endpoints.Authentication.LOGIN_BY_ID(),
		method: 'POST',
		data: params,
	}),
};

export default authenticationServices;
